import { render, staticRenderFns } from "./SkinFavouriteButton.vue?vue&type=template&id=2c1f21cc&scoped=true&"
import script from "./SkinFavouriteButton.vue?vue&type=script&lang=ts&"
export * from "./SkinFavouriteButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1f21cc",
  null
  
)

export default component.exports